module.exports = __webpack_public_path__ + "img/incendio.50831e13.png";